import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		await callback();
	} catch (e) {
		throw e.response.data;
	}
}
const Instance = {
	namespaced: true,
	state: {
		dataList: {	// paginatioin
			total: 0,
			list: []
		},
		ruleForm: {}
	},
	mutations: {},
	actions: {
		async getResourceList({ state }, query) {
			await HandleError(async () => {
				state.dataList = (await API.GetResourceList(query)).data;
			});
		},
		async createResource({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.createResource(query, data)).data;
			});
		},
		async updateResource({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.updateResource(query, data)).data;
			});
		},
		async deleteResource({ state }, { query, id }) {
			await HandleError(async () => {
				state.dataList = (await API.deleteResource(query, id)).data;
			});
		}
	}
};

export default Instance;